import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWeaveGroupBoard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.09304 3.25581C9.50406 3.30719 9.7956 3.68203 9.74423 4.09304L9.34961 7.25H15.3387L15.1512 8.75H4C3.58579 8.75 3.25 8.41421 3.25 8C3.25 7.58579 3.58579 7.25 4 7.25H7.83793L8.25581 3.90699C8.30719 3.49598 8.68203 3.20443 9.09304 3.25581Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.58793 9.25H9.09961L8.63086 13H8.62L7.87 19H7.88086L7.74423 20.093C7.69285 20.5041 7.31801 20.7956 6.90699 20.7442C6.49598 20.6928 6.20443 20.318 6.25581 19.907L6.65043 16.75H4C3.58579 16.75 3.25 16.4142 3.25 16C3.25 15.5858 3.58579 15.25 4 15.25H6.83793L7.58793 9.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6504 16.75H8.65125L8.83875 15.25H20C20.4142 15.25 20.75 15.5858 20.75 16C20.75 16.4142 20.4142 16.75 20 16.75H16.1621L15.7442 20.093C15.6928 20.5041 15.318 20.7956 14.907 20.7442C14.496 20.6928 14.2044 20.318 14.2558 19.907L14.6504 16.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1621 8.75L16.4121 14.75H14.9004L16.2558 3.90699C16.3072 3.49598 16.682 3.20443 17.093 3.25581C17.5041 3.30719 17.7956 3.68203 17.7442 4.09304L17.3496 7.25H20C20.4142 7.25 20.75 7.58579 20.75 8C20.75 8.41421 20.4142 8.75 20 8.75H17.1621Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconWeaveGroupBoard as ReactComponent };
